import { render, staticRenderFns } from "./ad-set-sort-arrows.vue?vue&type=template&id=8f93617e&scoped=true"
import script from "./ad-set-sort-arrows.vue?vue&type=script&lang=js"
export * from "./ad-set-sort-arrows.vue?vue&type=script&lang=js"
import style0 from "./ad-set-sort-arrows.vue?vue&type=style&index=0&id=8f93617e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f93617e",
  null
  
)

export default component.exports